import { Component, OnInit } from '@angular/core';
import { FileUploadModule } from 'primeng/fileupload';
import { TreeModule } from 'primeng/tree';
import { TreeNode } from 'primeng/api';
import { ReportingInstructionsService } from '../../services/reportinstructions.service';
import { ReportingInstructions, ReportMetadata } from '../../models/report.model';
import { NotifierService } from 'angular-notifier';
import { empty } from 'rxjs/Observer';
import { FileuploadComponent} from '../fileupload/fileupload.component';

@Component({
  selector: 'app-reportinginstructions',
  templateUrl: './reportinginstructions.component.html',
  styleUrls: ['./reportinginstructions.component.css']
})
export class ReportingInstructionsComponent implements OnInit {
  fileTree: TreeNode[] = [];
  reportTreeNode: ReportingInstructions[];
  nodeRoot: ReportingInstructions[];
  addFolder: ReportingInstructions[];
  uploadDocuments: ReportingInstructions[] = [];
  updateDocuments: ReportingInstructions[] = [];
  createFolder: boolean = false;
  uploadFile: boolean = false;
  nodeId: string;
  newFolderParentId: string;
  newDocumentParentId: string;
  FolderDocumentData: any[];
  uploadDocId: string;
  uploadDocParentId: string;
  loadDocumentId: string;
  documentName: string;
  fileType: string;


  constructor(
    private reportingstructionsService: ReportingInstructionsService,
    private notifier: NotifierService) {}

  ngOnInit() {

    // this.FolderDocumentData = [
    //   { id: 1, detail: 'Root Folder' },
    //   { id: 2, detail: 'Folder' },
    //   { id: 3, detail: 'Document' }
    // ];

    this.GetReportingInstructionsAll();
  }

  createFolderDialog(nodeId){
    // console.log("CREATE Folder Parent ID ----"+ nodeId);
    this.nodeId = null;
    this.createFolder = true;
    this.newFolderParentId = nodeId;
  }

  cancelFolderButton(){
    this.createFolder = false;
  }

  uploadDocumentDialog(nodeId){
    this.nodeId = null;
    this.uploadFile = true;
    this.newDocumentParentId = nodeId;
  }

  updateDocumentDialog(id, parentId){
    this.uploadFile = true;
    this.uploadDocId = id;
    this.uploadDocParentId = parentId;
  }

  updateDocument(file, fileContent, form)
  {
    this.updateDocuments.push({
      id: this.uploadDocId,
      parentId: null, // this.uploadDocParentId,
      type: 2,
      name: file.name,
      contentType: file.type,
      content: fileContent,
      contentLength: file.size,
    });
    console.log("Update Document content......"+ JSON.stringify(this.updateDocuments[0]));
    this.reportingstructionsService.updateDocument(this.updateDocuments[0]).subscribe(resp => {
      if (resp.ok) {
        this.notifier.notify('success', 'Document updated successfully');
        this.clearFiles(form);
        this.GetReportingInstructionsAll();
      }
    });
  }

  async onUpload(event, form) {
    // console.log("EVENT ----"+ JSON.stringify(event));
    console.log("CREATE File Parent ID ----"+ this.newDocumentParentId);
    for (let file of event.files) {
      // console.log("FILE Content ----"+ JSON.stringify(file.name) + "----" + file.type + "---" + file.size);
      var fileContent: any[] = [];
      var reader = new FileReader();
      reader.onload = function() {
        var arrayBuffer = this.result,
        array = new Uint8Array(arrayBuffer);
        //binaryString = String.fromCharCode.apply(null, array);
        if (array) {
          var byteArray = new Uint8Array(array);
          for (var i = 0; i < byteArray.byteLength; i++) {
            fileContent.push(byteArray[i]);
          }
        }
        // console.log("fileContent ------ "+fileContent);
      }
      reader.readAsArrayBuffer(file);
      if(this.uploadDocId != null){
        reader.onloadend = () => this.updateDocument(file, fileContent, form);
      }
      else{
        reader.onloadend = () => this.uploadDocument(file, fileContent, form);
      }
    }
  }

  clearFiles(form){
    this.uploadDocuments = [];
    this.uploadFile = false;    
    form.clear();
  }

  uploadDocument(file, fileContent, form){
    this.uploadDocuments.push({
      id: null,
      parentId: this.newDocumentParentId,
      type: 2,
      name: file.name,
      contentType: file.type,
      content: fileContent,
      contentLength: file.size,
    });
    console.log("File DATA---------------" + JSON.stringify(this.uploadDocuments[0]));
    this.reportingstructionsService.addReportingInstructions(this.uploadDocuments[0]).subscribe(resp => {
      if (resp.ok) {
        this.notifier.notify('success', 'Document uploaded successfully');
        this.clearFiles(form);
        this.GetReportingInstructionsAll();
      }
    });
  }

  deleteDocument(fileNodeId){
    //Delete the file
      this.reportingstructionsService.deleteDocument(fileNodeId).subscribe(resp => {
        if (resp.ok) {
          this.notifier.notify('success', 'Document deleted successfully');
        }
      });
    this.GetReportingInstructionsAll();
  }

  addFolderButton(folderName){
    this.addFolder = [];
      this.addFolder.push({
      id: null,
      parentId: this.newFolderParentId,
      type: 3,
      name: folderName,
      contentType: null,
      content: null,
      contentLength: null
      });
    this.reportingstructionsService.addReportingInstructions(this.addFolder[0]).subscribe(resp => {
      if (resp.ok) {
        this.notifier.notify('success', 'Created folder successfully');
      }else
      {
        this.notifier.notify('error', 'Duplicate Folder Name');
      }
    });
    this.cancelFolderButton();
    this.GetReportingInstructionsAll();
  }

  // addFileButton(){

  // }

  cancelDocumentUploadButton(){
    this.uploadFile = false;
  }

  GetReportingInstructionsAll() {
        this.reportingstructionsService.getReportingInstructionsByType(1).subscribe((data: ReportingInstructions[]) => {
        this.nodeRoot = data;
        for (let i = 0; i < this.nodeRoot.length; i++) {
            this.fileTree = [
            {
              label: this.nodeRoot[i].name,
              data: this.nodeRoot[i].id,
              // parentId: this.nodeRoot[i].parentId,
              children: this.getChildrenNodes(this.nodeRoot[i].id),
              leaf: false,
              // expandedIcon: this.nodeRoot[i].type == 1 ? 'expand' : '',
              // collapsedIcon: this.nodeRoot[i].type == 1 ? 'collaps' : '',
              expanded: this.nodeRoot[i].name == 'Root' ? true : false,
              selectable: false
            }
          ];
        }
      });
  }

getChildrenNodes(parentNodeId)
{
  var reportNode: TreeNode[] = [];
  this.reportingstructionsService.getReportingInstructionsByParentId(parentNodeId).subscribe((data: ReportingInstructions[]) => {
    this.reportTreeNode = data;
  for (let i = 0; i < this.reportTreeNode.length; i++)
  {
    var fileNode: TreeNode;
      fileNode =
        {
          label: this.reportTreeNode[i].name,
          data: this.reportTreeNode[i].id ,
          // parentId: this.reportTreeNode[i].parentId,
          children: this.reportTreeNode[i].type != 2 ? this.getChildrenNodes(this.reportTreeNode[i].id) : null,
          leaf:  this.reportTreeNode[i].type != 2 ? false : true,
          icon: (this.reportTreeNode[i].name).split('.',2)[1],
         // expandedIcon: this.reportTreeNode[i].type !== 2 ? 'expand': false, //this.getFileType((this.reportTreeNode[i].name).split('.',2)[1]) : 'fa fa-folder',
          //collapsedIcon: this.reportTreeNode[i].type !== 2 ? 'collaps': false, //this.getFileType((this.reportTreeNode[i].name).split('.',2)[1]) : 'fa fa-folder',
          expanded: this.reportTreeNode[i].type != 2 ? false : true,
          styleClass: this.reportTreeNode[i].type == 2 ? 'text-decoration:underline !important;' : '',
          selectable: false //this.reportTreeNode[i].type == 2 ? true : false
        }
      ;
      reportNode.push(fileNode);
  }
  });
    
  
return reportNode;
}

documentSelect(nodeId,fileName){
  this.loadDocumentId = nodeId;
  this.documentName = fileName;
  this.fileType = this.documentName.split('.',2)[1].toString();
  // console.log("FileName-----"+  this.fileType);
  // this.reportingstructionsService.downloadDocument$(this.loadDocumentId,this.fileType).subscribe((content:Blob)=>{
  //   const fileURL = URL.createObjectURL(content);
  //   window.open(fileURL, '_blank');
  // });
  this.reportingstructionsService.downloadDocument$(this.loadDocumentId,this.fileType);
}

  // nodeUnslect() {}

// getFileType(fileType){
// this.fileType = null;
// if(fileType == 'docx')
//   return 'fa fa-file-word-o';
// else if(fileType == 'txt')
//   return 'fa fa-file-text-o';
// else if(fileType == 'pdf')
//   return 'fa fa-file-pdf-o';
//   else if(fileType == 'xlsx')
//     return 'fa fa-file-excel-o';
// }

deleteFolder(nodeId){
  this.reportingstructionsService.getReportingInstructionsByParentId(nodeId).subscribe((data: ReportingInstructions[]) => {
      if (data.length > 0) {
        this.notifier.notify('error', 'Cannot Delete the folder, it has documents associated.');
      } else {
        this.deleteDocument(nodeId);
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/reportinginstructions/reportinginstructions/reportinginstructions.component.ts